/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useEffect, useState } from 'react';
import { useBlocker } from 'react-router-dom';
import { useFormikContext } from 'formik';
import { ConfirmDialog } from '@/components/dialogs/ConfirmDialog';

const FormNavigationBlocker = ({ formik  }) => {
	const { dirty, values, isSubmitting } = formik ?? useFormikContext();
	const [showDialog, setShowDialog] = useState(false);
	const [proceed, setProceed] = useState(null);

	const blocker = useBlocker(({ currentLocation, nextLocation }) => {
		if (isSubmitting) {
			return false;
		}

		return dirty && !values?.successMessage && currentLocation.pathname !== nextLocation.pathname;
	});

	useEffect(() => {
		if (blocker.state === 'blocked') {
			setShowDialog(true);
			setProceed(() => () => {
				blocker.proceed();
				setShowDialog(false);
			});
		}
	}, [blocker.state]);

	return (
		<>
			<ConfirmDialog
				openDialog={showDialog}
				handleClose={() => {
					setShowDialog(false);
					blocker.reset();
				}}
				handleConfirm={proceed ?? (() => {})}
				title='Leave page?'
				content='You may have unsaved changes. Are you sure you want to leave?'
				confirmText={'Leave page'}
			/>
		</>
	);
};
export default FormNavigationBlocker;
